import { Component, OnInit, Inject } from '@angular/core';
import { RmsModule } from '@rms';
import { WebService, lastValueFrom, RmsMessageService } from '@services';
import { RmsPulldownRef } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';

@Component({
  selector: 'app-container-details',
  standalone: true,
  imports: [RmsModule],
  templateUrl: './container-details.component.html',
  styleUrl: './container-details.component.scss'
})
export class ContainerDetailsComponent implements OnInit {
  containerID: number;
  items: any[] = [];
  loading = false;
  saving = false;
  get canReopen() { return this.pulldownData?.status === 'ON_CONTAINER' && !this.loading && this.items.length > 0; }

  async reopen() {
    if (!this.canReopen || this.saving) return;
    this.saving = true;
    try {
      await lastValueFrom(this.webService.getWebCall('inventory', 'coffee/inventory/transfer/reopen', { body: { ContainerID: this.containerID } }));
      this.message.success('Load returned to holding. You can now adjust its references and rebuild the load.');
      this.rmsPulldownRef.close({ reopened: true });
    } catch (err: any) {
      this.message.error(err?.error?.error ?? 'Could not return this load to holding.');
    } finally { this.saving = false; }
  }

  constructor(
    private webService: WebService,
    private message: RmsMessageService,
    private rmsPulldownRef: RmsPulldownRef,
    @Inject(RMS_PULLDOWN_DATA) private pulldownData: any
  ) {
    this.containerID = this.pulldownData?.containerID;
  }

  async ngOnInit() {
    this.loading = true;
    try {
      this.items = await lastValueFrom(
        this.webService.getWebCall('inventory', `coffee/inventory/transfer/container/${this.containerID}/items`)
      );
    } catch (err) {
      console.error('Failed to load container line items', err);
      this.message.error('Could not load the items in this container.');
    } finally {
      this.loading = false;
    }
  }

  close() {
    this.rmsPulldownRef.close();
  }
}
